// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgSearch: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      role="presentation"
      {...props}
    >
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path
          fillRule="evenodd"
          d="M17.193 18.59A10.457 10.457 0 0 1 10.5 21C4.701 21 0 16.299 0 10.5S4.701 0 10.5 0 21 4.701 21 10.5a10.45 10.45 0 0 1-2.41 6.693 1 1 0 0 1 .117.1l5 5a1 1 0 0 1-1.414 1.414l-5-5a1 1 0 0 1-.1-.116M19 10.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

const Memo = memo(SvgSearch);
export default Memo;
